import {Asset} from "../models/asset";
import {IAssetResolver} from "../asset-resolver.interface";
export function makeAssets(assetsResolver: IAssetResolver) {
	return {
		fonts: {
			Jaldi_Bold_eot: new Asset('fonts/Jaldi-Bold.eot', assetsResolver),
			Jaldi_Bold_ttf: new Asset('fonts/Jaldi-Bold.ttf', assetsResolver),
			Jaldi_Bold_woff: new Asset('fonts/Jaldi-Bold.woff', assetsResolver),
			Jaldi_Regular_eot: new Asset('fonts/Jaldi-Regular.eot', assetsResolver),
			Jaldi_Regular_ttf: new Asset('fonts/Jaldi-Regular.ttf', assetsResolver),
			Jaldi_Regular_woff: new Asset('fonts/Jaldi-Regular.woff', assetsResolver),
		},
	}
}
